import { render, staticRenderFns } from "./PaidAssignments.vue?vue&type=template&id=021e4764&"
import script from "./PaidAssignments.vue?vue&type=script&lang=js&"
export * from "./PaidAssignments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports